module.exports = __webpack_public_path__ + "img/bell_6.40d3a72c.jpg";